import React from 'react';
import './CollabCard.scss';
import { ha, vcmint, pentathlonv, chennaiangels, gsf, faadcapital, haf, ian } from 'src/assets/images';
const CollabCard: React.FC<{ collabProp?: string }> = ({ collabProp }) => {
    let logo = ha;
    let invName = "Hyderabad Angels";
    if (collabProp === '6928114050644500111ffebd') {
        // You can set different logo and name for this prop if needed
        logo = ha; // Replace with actual logo for this prop
        invName = "Hyderabad Angels"; // Replace with actual name for this prop
    } else if (collabProp === '694a86a51eb73f0011898531') {
        logo = vcmint;
        invName = "VCMint";
    } else if (collabProp === '698055b6ffab65001131a971') {
        logo = pentathlonv;
        invName = "Pentathlon Ventures";
    } else if (collabProp === '698c77905c1b4800115eee5e') {
        logo = chennaiangels;
        invName = "The Chennai Angels";
    } else if (collabProp === '6992b4c63cbfb300118e4fc1') {
        logo = gsf;
        invName = "GSF";
    } else if (collabProp === '69b7834db7797a0011d5fc0e') {
        logo = faadcapital;
        invName = "Faad Capital";
    } else if (collabProp === '69b78182b7797a0011d5e59b') {
        logo = haf;
        invName = "Hyderabad Angels Fund";
    } else if (collabProp === '69d39ef9f38d890011aa2fe3') {
        logo = ian;
        invName = "Indian Angel Network";
    }
  return (<>
    <div className='content'>
        <div className='logo'>
            <div className='circle-1'>
                <div className='circle-2'>
                    <div className='circle-3'>
                        <div className='circle-4'>
                            <img src={ logo } alt="our partner logo"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className='heading'>
            {invName} x htraction
        </div>
        <div className='para'>
            {invName} has partnered with htraction to bring speed, standardization, and trust into the application & funding process.
        </div>
    </div>

  </>);
};

export default CollabCard;
